<script lang="ts">
	import type { ProductConfig } from '$lib/brand/types';

	interface Props {
		product: ProductConfig;
		className?: string;
	}

	let { product, className = '' }: Props = $props();

	const formattedPrice = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: product.currency
	}).format(product.price);
</script>

<div class="product-hero {className}">
	{#if product.imageUrl}
		<div class="product-image">
			<img src="{product.imageUrl}" alt="{product.name}" />
		</div>
	{/if}

	<div class="product-info">
		<h1>{product.name}</h1>
		<div class="price">{formattedPrice}</div>
		<p class="description">{product.description}</p>

		<div class="cta-section">
			<a href="{product.checkoutUrl}" class="buy-button" target="_blank" rel="noopener noreferrer">
				Buy Now
			</a>
                        <p class="checkout-note">Secure checkout powered by Kit</p>
		</div>
	</div>
</div>

<style>
	.product-hero {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 3rem;
		align-items: center;
		margin-bottom: 3rem;
	}

	.product-image img {
		width: 100%;
		height: auto;
		border-radius: 8px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	}

	.product-info h1 {
		font-size: 2.5rem;
		color: var(--brand-primary);
		margin-bottom: 1rem;
		line-height: 1.2;
	}

	.price {
		font-size: 2rem;
		font-weight: bold;
		color: var(--brand-secondary);
		margin-bottom: 1.5rem;
	}

	.description {
		font-size: 1.25rem;
		color: #64748b;
		line-height: 1.6;
		margin-bottom: 2rem;
	}

	.cta-section {
		text-align: center;
	}

	.buy-button {
		display: inline-block;
		background: var(--brand-primary);
		color: white !important;
		padding: 1rem 2rem;
		font-size: 1.25rem;
		font-weight: 600;
		text-decoration: none;
		border-radius: 8px;
		transition: all 0.3s ease;
		margin-bottom: 1rem;
	}

	.buy-button:hover {
		background: var(--brand-secondary);
		color: white !important;
		transform: translateY(-2px);
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
	}

	.checkout-note {
		font-size: 0.9rem;
		color: #64748b;
		margin: 0;
	}

	@media (max-width: 768px) {
		.product-hero {
			grid-template-columns: 1fr;
			gap: 2rem;
			text-align: center;
		}

		.product-info h1 {
			font-size: 2rem;
		}

		.price {
			font-size: 1.75rem;
		}

		.description {
			font-size: 1.1rem;
		}

		.buy-button {
			font-size: 1.1rem;
			padding: 0.875rem 1.75rem;
		}
	}
</style>
